import { FC } from "react"
import { DLMSiteApplication } from "../../../../_models"
import { isPopulatedArray } from "../../../../../../../components/helpers"
import { useSiteLabellingState } from "./_store"
import { PropsWithNotes, ToggleNotesCell } from "../../../../../../../components/table"

type Props = {
  row: PropsWithNotes<DLMSiteApplication>  
}

const DLMLabellingNotesCell: FC<Props> = ({row}) => {    

  const { id, showNotes, notes, requestTerminateNotes : terminationNotes } = row;
  
  const toggleNotes = useSiteLabellingState(state => state.toggleNotes);

  return (
    <ToggleNotesCell id={id} show={showNotes} hasNotes={(isPopulatedArray(notes) || isPopulatedArray(terminationNotes))} toggleNotes={toggleNotes} />
  )
  
}

export {DLMLabellingNotesCell}
